import {ValueObject} from '@s-ui/domain'

import {SegmentValueObject} from '../ValueObjects/SegmentValueObject.js'

export class UserAlertsMatchesPageTrackingValueObject extends ValueObject {
  #trackingData

  constructor({trackingData}) {
    super()
    this.#trackingData = trackingData
  }

  static create({trackingData}) {
    return new UserAlertsMatchesPageTrackingValueObject({trackingData})
  }

  static createFromConfig({config}) {
    const trackingConfig = config.get('tracking')

    return UserAlertsMatchesPageTrackingValueObject.create({
      trackingData: SegmentValueObject.create({
        channel: trackingConfig.TRACKING_DATA_BY_PAGE.USER_ALERTS_MATCHES.channel,
        eventName: trackingConfig.TRACKING_DATA_BY_PAGE.USER_ALERTS_MATCHES.eventName,
        pageCategoryLevel1: trackingConfig.TRACKING_DATA_BY_PAGE.USER_ALERTS_MATCHES.pageCategoryLevel1,
        pageName: trackingConfig.TRACKING_DATA_BY_PAGE.USER_ALERTS_MATCHES.pageName,
        pageType: trackingConfig.TRACKING_DATA_BY_PAGE.USER_ALERTS_MATCHES.pageType
      })
    })
  }

  get trackingData() {
    return this.#trackingData.value
  }

  getValue() {
    return {trackingData: this.trackingData}
  }

  getSegmentTrack() {
    return this.#trackingData.toSegmentTrack()
  }

  toJSON() {
    return {trackingData: this.#trackingData.toJSON()}
  }
}
